import './Banner.css';
import React from 'react';
import { Icon } from '../Icon/Icon';
import GlobalProps from '../globalProps';
import classnames from 'classnames';

interface Props extends GlobalProps {
  open?: boolean;
  title?: string;
  footer?: React.ReactNode;
  onClose?: () => void;
}

export function Banner({ open, title, style, className, children, footer, onClose }: Props): JSX.Element | null {
  if (!open) {
    return null;
  }

  return (
    <div
      className={classnames('banner', className, {
        'banner--no-footer': !footer,
      })}
      style={style}
    >
      <header className="banner__header">
        <h1 className="banner__title">{title}</h1>
        <div className="banner__close">
          <Icon name="remove" onClick={onClose} />
        </div>
      </header>
      <article className="banner__body">{children}</article>
      {footer && <footer className="banner__footer">{footer}</footer>}
    </div>
  );
}
